// import {
//     Message
// } from 'element-ui';

// num传入的数字，n需要的字符长度 --数字补零
const PrefixInteger = function (num, n) {
    return (Array(n).join(0) + num).slice(-n);
};

//数字补零
const add0 = function (m) {
    return m < 10 ? '0' + m : m
};

//验证手机--正则
// const ifPhone = function (phone) {
//     let retphone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
//     if (!retphone.test(phone)) {
//         Message.warning('请输入正确的手机号码！')
//         return false;
//     } else {
//         return true
//     }
// }

//验证QQ
// const isQQ = function (qq) {
//     if (qq.search(/^[1-9]\d{4,8}$/) != -1) {
//         return true;
//     } else {
//         Message.warning('qq格式错误')
//         return false;
//     }
// }
// 验证座机和传真
// var isTelOrFax = (value) => {
//     if (!value) {
//         return true;
//     } else {
//         const reg = /^(\d{3,4}-)?\d{7,8}$/;
//         const isTel = reg.test(value);
//         if (value.length < 10 || value.length > 13 || !isTel) {
//             //判断传真字符范围是在10到13
//             Message.warning('座机或传真格式如:0376-1234567')
//         } else {
//             return false;
//         }
//     }
// };

// 验证邮箱
// var isEmail = (rule, value, callback) => {
//     if (!value) {
//         callback();
//     } else {
//         const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
//         const email = reg.test(value);
//         if (!email) {
//             callback(new Error("邮箱格式如:admin@163.com"));
//         } else {
//             callback();
//         }
//     }
// };

// 验证身份证号
// var isCardId = (rule, value, callback) => {
//     if (!value) {
//         return new Error("请输入身份证号)");
//     } else {
//         const reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
//         const card = reg.test(value);
//         if (!card) {
//             //判断座机为12位
//             callback(new Error("身份证格式如:423024xxxx0216xxxx"));
//         } else {
//             callback();
//         }
//     }
// };


/*  获取随机码
	codeLength: 随机数长度
*/
const getStateCode = function (codeLength) {
    var UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var LOWER = UPPER.toLocaleLowerCase();
    var DIGITS = "0123456789";
    var ALPHA_NUMBER = UPPER + LOWER + DIGITS;
    //字符串转成数组
    var symbols = new Array()
    for (let i = 0; i < ALPHA_NUMBER.length; i++) {
        symbols[i] = ALPHA_NUMBER.charAt(i)
    }
    //随机拼接字符串
    var stateCode = "";
    for (let i = 0; i < codeLength; i++) {
        stateCode += symbols[Math.floor((Math.random() * symbols.length))];
    }
    return stateCode;
}

export default {
    // showToast,
    PrefixInteger,
    // getToken,
    // ifPhone,
    add0,
    getStateCode,
}